export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";